import $ from "jquery";

$(function () {
    const $banner = $(".nda-banner");
    const bannerClosedKey = "notificationBannerClosed";

    // Only show the banner if it hasn't been closed in this session
    if (sessionStorage?.getItem(bannerClosedKey) !== "true") {
        if ($banner.attr("data-home") === "true") {
            $banner.css({ display: "flex" }).animate({ marginTop: 0, opacity: 1 }, 1200);
        } else {
            $banner.css({ display: "flex", marginTop: 0, opacity: 1 });
        }

        $(".page-sidebar .panel")?.css({ top: "7rem" });
        $("header.header")?.toggleClass("banner-visible", true);
    } else {
        $banner.hide();
    }

    $("button", $banner).on("click", function () {
        $banner.hide();
        sessionStorage?.setItem(bannerClosedKey, "true");
        $("header.header")?.toggleClass("banner-visible", false);
    });
});
